export default (props) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    data-testid="icon-pin"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect x="0" y="0" width="24" height="24" />
      <path
        d="M8.74648525,7.0952381 C8.16790123,7.0952381 7.6988662,6.62620307 7.6988662,6.04761905 C7.6988662,5.46903502 8.16790123,5 8.74648525,5 L15.0321995,5 C15.6107836,5 16.0798186,5.46903502 16.0798186,6.04761905 C16.0798186,6.62620307 15.6107836,7.0952381 15.0321995,7.0952381 L14.50839,7.0952381 L14.5082472,11.809 L15.8179138,11.8095238 C16.5411439,11.8095238 17.1274376,12.3958176 17.1274376,13.1190476 C17.1274376,13.8422776 16.5411439,14.4285714 15.8179138,14.4285714 L12.4122472,14.428 L12.4131519,19.1428571 C12.4131519,19.4321492 12.1786344,19.6666667 11.8893424,19.6666667 C11.6000504,19.6666667 11.3655329,19.4321492 11.3655329,19.1428571 L11.3652472,14.428 L7.96077096,14.4285714 C7.23754093,14.4285714 6.65124715,13.8422776 6.65124715,13.1190476 C6.65124715,12.3958176 7.23754093,11.8095238 7.96077096,11.8095238 L9.27024715,11.809 L9.27029477,7.0952381 L8.74648525,7.0952381 Z"
        fill="currentColor"
        fillRule="nonzero"
        transform="translate(11.889342, 12.333333) rotate(-315.000000) translate(-11.889342, -12.333333) "
      />
    </g>
  </svg>
);
